import React, { useEffect, useState } from "react";
import MaterialUiRating from "@mui/material/Rating";
import Slider from "@mui/material/Slider";

export default function RatingInput(props) {
  const {
    id,
    value,
    label,
    required,
    readOnly,
    onChange,
    isSlider,
    minRange,
    maxRange,
  } = props;

  const [internalValue, setInternalValue] = useState(value);

  const handleOnChange = (newValue) => {
    setInternalValue(newValue);
    onChange(id, newValue);
  };

  useEffect(() => {
    if (internalValue !== value) {
      setInternalValue(value);
    }
  }, [value]);

  if (!isSlider) {
    return (
      <div className="col-12">
        <h4 id={id}>{label}</h4>
        <MaterialUiRating
          readOnly={readOnly}
          required={required}
          name="size-large"
          defaultValue={2.5}
          value={internalValue}
          size="large"
          onChange={(_, newValue) => {
            handleOnChange(newValue);
          }}
          precision={0.5}
        />
      </div>
    );
  }

  const marks = [];
  for (let i = minRange; i <= maxRange; i++) {
    marks.push({
      value: i,
      label: i,
    });
  }

  return (
    <div className="col-12">
      <h4 id={id}>{label}</h4>
      <Slider
        readOnly={readOnly}
        required={required}
        aria-label="Volume"
        value={internalValue}
        onChange={(_, newValue) => {
          handleOnChange(newValue);
        }}
        min={minRange}
        max={maxRange}
        step={1}
        valueLabelDisplay="on"
        marks={marks}
      />
    </div>
  );
}
